<script setup>
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '.'
import { computed } from 'vue'
import Separator from '../separator/Separator.vue';

const props = defineProps({
  modelValue: { type: [String, Number], required: false },
  placeholder: { type: String, required: false },
  type: { type: String, required: false, default: 'text' },
  addonText: { type: String, required: false },
  errorMessages: { type: Array, default: () => [] },
  showPrependSeparator: { type: Boolean, default: true },
})

const emit = defineEmits(['update:modelValue'])

const hasErrors = computed(() => props.errorMessages && props.errorMessages.length > 0);

// Disable automatic attribute inheritance to manually control where attributes go
defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <InputGroup :class="[hasErrors ? 'border-red-500' : '']">
    <InputGroupAddon v-if="$slots.prepend" align="inline-start">
      <slot name="prepend" />
    </InputGroupAddon>
    <Separator v-if="showPrependSeparator" orientation="vertical" class="bg-primary-border" />
    <InputGroupInput 
      :model-value="modelValue"
      @update:model-value="emit('update:modelValue', $event)"
      :placeholder="placeholder" 
      :type="type"
      v-bind="$attrs"
    />
    
    <InputGroupAddon v-if="$slots.append" align="inline-end">
      <slot name="append" />
    </InputGroupAddon>
  </InputGroup>
  <div v-if="hasErrors" class="text-xs text-red-500 mt-1">
    <div v-for="message in errorMessages" :key="message">
      {{ message }}
    </div>
  </div>
</template>
